export default "__VITE_ASSET__BxQaAhD5__"